<template>
  <div 
    :style="`margin-top: ${top}px`" 
    class="swiperImgTxt"  
  >
    <div class="swiper-container" ref="swiperContainer">
      <ul class="swiper-wrapper">
        <li 
          class="swiper-slide"
          v-for="(item, index) in list"
          :key="item.id"
          @click="showDetails(index)"  
        >
          <div class="itemImg">
            <img :src="item.src"/>
          </div>
          <h6 class="itemTitle">{{item.title}}</h6>
          <p class="txt txt1">落款：{{item.inscribe}}</p>
          <p class="txt txt2">{{item.type}}</p>
          <p class="txt txt3">{{item.size}}</p>
        </li>
      </ul>
    </div>
    <div class="changeBtn prevBtn" @click="swiperToPrev" v-show="nowPage !== 0">
      <img :src="backBtn"/>
    </div>
    <div class="changeBtn nextBtn" @click="swiperToNext" v-show="nowPage < list.length - 3">
      <img :src="backBtn"/>
    </div>
  </div>  
</template>

<script>
import Swiper from 'swiper'
import { swiperMixin } from '@/utils/mixin.js'

import backBtn from '@/assets/img/backBtn.png'

export default {
  mixins: [swiperMixin],
  props: {
    top: {
      type: String,
      default: '0'
    },
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },

  data () {
    return {
      backBtn,
      imgSwiper: null,
      nowPage: 0,
    }
  },

  mounted () {
    this.initSwiper()
  },

  methods: {
    initSwiper () { // 初始化swiper
      let _this = this
      this.imgSwiper = new Swiper(this.$refs.swiperContainer, {
        observer: true, 
        observeParents: true,
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        on: {
          slideChangeTransitionEnd: function(){
            _this.nowPage = this.realIndex
          },
        }
      })
    },

    swiperToNext () { // 下一个
      this.imgSwiper.slideNext();
    },

    swiperToPrev () { // 上一个
      this.imgSwiper.slidePrev();
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './swiperImgTxt.styl'
</style>